import {
  IconTrophy,
  IconUsers,
  IconClock,
  IconShield,
  IconStar,
  IconCheck,
} from "@/components/ui-sr/icons";

const TICKER_ITEMS = [
  {
    icon: <IconTrophy className="w-5 h-5" />,
    value: "600 mil+",
    label: "Bens entregues",
  },
  {
    icon: <IconUsers className="w-5 h-5" />,
    value: "250 mil+",
    label: "Clientes ativos",
  },
  {
    icon: <IconClock className="w-5 h-5" />,
    value: "2.500+",
    label: "Contemplações/mês",
  },
  {
    icon: <IconShield className="w-5 h-5" />,
    value: "38 anos",
    label: "De tradição",
  },
  {
    icon: <IconStar className="w-5 h-5" />,
    value: "Selo RA1000",
    label: "Reclame Aqui",
  },
  {
    icon: <IconCheck className="w-5 h-5" />,
    value: "ISO 9001",
    label: "Certificada",
  },
  {
    icon: <IconTrophy className="w-5 h-5" />,
    value: "GPTW",
    label: "Melhores empresas",
  },
  {
    icon: <IconShield className="w-5 h-5" />,
    value: "Bacen",
    label: "Regulamentada",
  },
];

/**
 * Ticker horizontal infinito de prova social (números administradora parceira).
 * Pausa no hover; sem animação se prefers-reduced-motion.
 */
export function SocialProofTicker() {
  return (
    <section
      className="w-full bg-[var(--sr-navy)] py-6 sm:py-8 overflow-hidden"
      aria-label="Prova social"
    >
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-[var(--sr-navy)] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-[var(--sr-navy)] to-transparent z-10 pointer-events-none" />
        <div className="flex animate-[ticker_30s_linear_infinite] hover:[animation-play-state:paused]">
          {[...Array(2)].map((_, setIdx) => (
            <div
              key={setIdx}
              className="flex shrink-0"
              aria-hidden={setIdx === 1}
            >
              {TICKER_ITEMS.map((item, i) => (
                <div
                  key={`${setIdx}-${i}`}
                  className="flex items-center gap-3 px-6 sm:px-8 py-3 shrink-0"
                >
                  <div className="text-[var(--sr-gold)]">{item.icon}</div>
                  <div>
                    <div className="text-white text-sm sm:text-base font-bold whitespace-nowrap">
                      {item.value}
                    </div>
                    <div className="text-white/60 text-[10px] sm:text-xs whitespace-nowrap">
                      {item.label}
                    </div>
                  </div>
                  <div className="w-px h-8 bg-white/10 ml-6" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
